<app-catalog-page-card title="VENDOR TYPES">
  <app-catalog-table-toolbar
    datatableId="kt_vendor_type_datatable"
    searchPlaceholder="Search vendor type records..."
    addButtonLabel="Add Vendor Type"
    addModalId="create_vendor_type_modal"
    refreshAriaLabel="Refresh vendor types"
    [disableRefresh]="isLoading()"
    (refresh)="loadVendorTypes()"
  ></app-catalog-table-toolbar>

  <app-catalog-crud-modal
    modalId="create_vendor_type_modal"
    title="Create Vendor Type"
    submitLabel="Create Vendor Type"
    [submitting]="isCreating()"
    [formError]="createFormError()"
    (submit)="onCreateVendorType()"
    (cancel)="resetCreateVendorTypeForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="createVendorTypeForm">
        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-vendor-type-code">
            Code <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="create-vendor-type-code"
            type="text"
            class="kt-input"
            maxlength="30"
            formControlName="code"
            [attr.aria-invalid]="shouldShowCreateFieldError('code')"
          />

          @if (shouldShowCreateRequiredError('code')) {
            <div class="catalog-field-error">Code is required.</div>
          }

          @if (shouldShowCreateMaxLengthError('code')) {
            <div class="catalog-field-error">Code cannot exceed 30 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-vendor-type-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="create-vendor-type-name"
            type="text"
            class="kt-input"
            maxlength="100"
            formControlName="name"
            [attr.aria-invalid]="shouldShowCreateFieldError('name')"
          />

          @if (shouldShowCreateRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowCreateMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 100 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-vendor-type-description">Description</label>
          <input
            id="create-vendor-type-description"
            type="text"
            class="kt-input"
            maxlength="200"
            formControlName="description"
            [attr.aria-invalid]="shouldShowCreateFieldError('description')"
          />

          @if (shouldShowCreateMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 200 characters.</div>
          }
        </div>

        <label class="flex items-center gap-2.5">
          <input type="checkbox" class="kt-checkbox" formControlName="isActive" />
          <span class="kt-form-label mb-0">Active</span>
        </label>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#edit_vendor_type_modal"
  ></button>

  <app-catalog-crud-modal
    modalId="edit_vendor_type_modal"
    title="Edit Vendor Type"
    submitLabel="Save Changes"
    [submitting]="isUpdating()"
    [formError]="editFormError()"
    (submit)="onUpdateVendorType()"
    (cancel)="resetEditVendorTypeForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="editVendorTypeForm">
        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-vendor-type-code">
            Code <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="edit-vendor-type-code"
            type="text"
            class="kt-input"
            maxlength="30"
            formControlName="code"
            [attr.aria-invalid]="shouldShowEditFieldError('code')"
          />

          @if (shouldShowEditRequiredError('code')) {
            <div class="catalog-field-error">Code is required.</div>
          }

          @if (shouldShowEditMaxLengthError('code')) {
            <div class="catalog-field-error">Code cannot exceed 30 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-vendor-type-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="edit-vendor-type-name"
            type="text"
            class="kt-input"
            maxlength="100"
            formControlName="name"
            [attr.aria-invalid]="shouldShowEditFieldError('name')"
          />

          @if (shouldShowEditRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowEditMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 100 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-vendor-type-description">Description</label>
          <input
            id="edit-vendor-type-description"
            type="text"
            class="kt-input"
            maxlength="200"
            formControlName="description"
            [attr.aria-invalid]="shouldShowEditFieldError('description')"
          />

          @if (shouldShowEditMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 200 characters.</div>
          }
        </div>

        <label class="flex items-center gap-2.5">
          <input type="checkbox" class="kt-checkbox" formControlName="isActive" />
          <span class="kt-form-label mb-0">Active</span>
        </label>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#delete_vendor_type_confirm_modal"
  ></button>

  <app-catalog-delete-confirm-modal
    modalId="delete_vendor_type_confirm_modal"
    title="Remove Vendor Type"
    message="Are you sure you want to remove this vendor type?"
    confirmLabel="Remove Vendor Type"
    [confirming]="deletingVendorTypeId() !== null"
    (confirm)="confirmDeleteVendorType()"
    (cancel)="cancelDeleteVendorType()"
  ></app-catalog-delete-confirm-modal>

  @if (hasAlert()) {
    <div
      class="kt-alert kt-alert-light"
      [class.kt-alert-success]="alertVariant() === 'success'"
      [class.kt-alert-destructive]="alertVariant() === 'destructive'"
      role="alert"
    >
      <div class="kt-alert-icon">
        <i class="ki-filled ki-information" aria-hidden="true"></i>
      </div>

      <div class="grow">
        <div class="kt-alert-title"><strong>{{ alertTitle() }}</strong></div>

        @if (alertMessage()) {
          <div class="kt-alert-text">{{ alertMessage() }}</div>
        }
      </div>

      <div class="kt-alert-toolbar">
        <div class="kt-alert-actions">
          <button type="button" class="kt-alert-close" aria-label="Dismiss alert" (click)="dismissAlert()">
            <i class="ki-filled ki-cross" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  }

  @if (isLoading()) {
    <div class="catalog-loading" role="status" aria-live="polite" aria-label="Loading vendor types">
      <span class="catalog-loading-spinner" aria-hidden="true"></span>
      <span class="catalog-loading-text">Loading...</span>
    </div>
  }

  @if (!isLoading() && errorMessage()) {
    <div class="kt-alert kt-alert-destructive flex items-center justify-between gap-3">
      <span>{{ errorMessage() }}</span>
      <button type="button" class="kt-btn kt-btn-sm kt-btn-light" (click)="loadVendorTypes()">Retry</button>
    </div>
  }

  @if (!isLoading() && !errorMessage()) {
    <div
      id="kt_vendor_type_datatable"
      class="kt-card-table"
      data-kt-datatable="true"
      data-kt-datatable-page-size="20"
      data-kt-datatable-state-save="true"
      data-kt-datatable-state-namespace="vendor-type-datatable"
      (click)="onTableActionClick($event)"
    >
      <div class="kt-table-wrapper kt-scrollable">
        <table class="kt-table" data-kt-datatable-table="true">
          <thead>
            <tr>
              <th scope="col" data-kt-datatable-column="code">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Code</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="name">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Name</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="description">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Description</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="vendors">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Vendors</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="status">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Status</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th
                scope="col"
                data-kt-datatable-column="actions"
                data-kt-datatable-column-sort="false"
                class="text-end"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            @if (vendorTypes().length === 0) {
              <tr>
                <td colspan="6" class="text-center text-secondary-foreground py-6">No vendor types found.</td>
              </tr>
            } @else {
              @for (item of vendorTypes(); track item.id) {
                <tr>
                  <td>{{ item.code }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.description || '-' }}</td>
                  <td>{{ item.vendorCount }}</td>
                  <td>
                    <span class="kt-badge kt-badge-sm" [class.kt-badge-success]="item.isActive" [class.kt-badge-light]="!item.isActive">
                      {{ item.isActive ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td class="text-end">
                    <span class="inline-flex gap-2.5">
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Edit vendor type"
                        data-action="edit-vendor-type"
                        [attr.data-vendor-type-id]="item.id"
                        [disabled]="deletingVendorTypeId() !== null || isUpdating()"
                      >
                        <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Remove vendor type"
                        data-action="delete-vendor-type"
                        [attr.data-vendor-type-id]="item.id"
                        [disabled]="deletingVendorTypeId() !== null"
                      >
                        <i class="ki-filled ki-trash" aria-hidden="true"></i>
                      </button>
                    </span>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="flex items-center justify-between gap-4 flex-wrap px-5 py-4">
        <div data-kt-datatable-info="true" class="kt-datatable-info text-sm text-secondary-foreground"></div>

        <div class="kt-datatable-length flex items-center gap-3">
          <select data-kt-datatable-size="true" class="kt-select kt-select-sm w-20"></select>
          <div data-kt-datatable-pagination="true" class="kt-datatable-pagination flex items-center gap-2"></div>
        </div>
      </div>
    </div>
  }
</app-catalog-page-card>
